import { TimelineItemStatus } from '@components'

import { RecurringInvoiceEventType } from '@features/recurringInvoices/enums/recurringInvoiceEventType'

export const getTimelineStatusByRecurringInvoiceEventType = (
  eventType: RecurringInvoiceEventType,
): TimelineItemStatus => {
  switch (eventType) {
    case RecurringInvoiceEventType.ProfileCompleted:
      return 'success'
    case RecurringInvoiceEventType.ProfileScheduleActionFail:
    case RecurringInvoiceEventType.ProfileAccountingComplianceFail:
    case RecurringInvoiceEventType.ProfileScheduleActionFailSend:
    case RecurringInvoiceEventType.ProfileScheduleSubscriptionFail:
      return 'error'
    default:
      return 'neutral'
  }
}
